var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Material
import { Box, Stack } from "@mui/material";
import { lighten } from "@mui/material/styles";
import Text from "../../../../Atoms/Text";
import { COLORS } from "../../../../../constants/colors";
// Comps
import Logo from "../../Atoms/Logo";
var MessageHeader = function (_a) {
    var title = _a.title, logoUrl = _a.logoUrl;
    return (_jsxs(Box, { children: [_jsx(Stack, __assign({ direction: "row", justifyContent: "center", px: 3, py: 4, sx: {
                    backgroundColor: lighten(COLORS.LIGHT_GREY, 0.5),
                    alignItems: "center",
                } }, { children: _jsx(Box, __assign({ width: "90%", textAlign: "center" }, { children: _jsx(Text, __assign({ variant: "overline", emphasis: "medium", component: "p" }, { children: title })) })) })), _jsx(Box, __assign({ display: "flex", flexDirection: "row", justifyContent: "center", mt: -3, mb: 5 }, { children: _jsx(Logo, { logoUrl: logoUrl, diameter: 44, blankSpace: 2.5 }) }))] }));
};
export default MessageHeader;
